import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Tabs, Button, Typography } from 'antd';
import ProjectOverviewTab from '../ProjectOverviewTab/ProjectOverviewTab';
import ProjectStageTab from '../ProjectStageTab/ProjectStageTab';

const { TabPane } = Tabs;
const { Title } = Typography;

const ProjectTabs = ({ userView }) => {
  const [activeKey, setActiveKey] = useState('1');
  const [localTab, setLocalTab] = useState([]);
  const [newTabIndex, setNewTabIndex] = useState(0);
  const [editing, setEditing] = useState(false);

  const currentProject = useSelector((state) => state.currentProject);
  let currentStages = [];
  if (currentProject.stages) {
    currentStages = currentProject.stages.map((stage) => ({
      title: stage.name,
      content: (
        <ProjectStageTab
          data={stage}
          projectId={currentProject.id}
          activeKey={activeKey}
          thisKey={`stage-${stage.id}`}
          userView={userView}
        />
      ),
      key: `stage-${stage.id}`,
      closable: false,
    }));
  }

  const tabs = [
    {
      title: 'Informacje ogólne',
      content: (
        <ProjectOverviewTab
          data={currentProject}
          userView={userView}
          // isEditing={currentProjectIsEditing}
        />
      ),
      key: '1',
      closable: false,
    },
    ...currentStages,
  ];
  // const [panes, setPanes] = useState(startPanes);

  const onChange = (activeKey) => {
    setActiveKey(activeKey);
  };

  useEffect(() => {
    setLocalTab([]);
    setActiveKey('1');
  }, [currentProject]);

  // const onEdit = (targetKey, action) => {
  //   if (action === 'add') {
  //     add();
  //   } else {
  //     // remove(targetKey);
  //   }
  // };

  const add = () => {
    const activeKey = `temp-stage${newTabIndex}`;
    setNewTabIndex(newTabIndex + 1);
    setLocalTab([
      {
        title: 'Nowy Etap',
        content: (
          <ProjectStageTab
            data={''}
            isEditing={true}
            projectId={currentProject.id}
            userView={userView}
          />
        ),
        key: activeKey,
        closable: false,
      },
    ]);
    setActiveKey(activeKey);
  };
  /*
const remove = targetKey => {
  let lastIndex;
  panes.forEach((pane, i) => {
    if (pane.key === targetKey) {
      lastIndex = i - 1;
    }
  });
  const newPanes = panes.filter(pane => pane.key !== targetKey);
  if (newPanes.length && activeKey === targetKey) {
    if (lastIndex >= 0) {
      setActiveKey(newPanes[lastIndex].key);
    } else {
      setActiveKey(newPanes[0].key);
    }
  }
  setPanes([...newPanes]);
};
/**/

  return (
    <>
      <Title
        level={3}
        style={{ marginBottom: '24px', marginTop: '0px', height: '36px' }}
      >
        {currentProject.name
          ? `${currentProject.number} - ${currentProject.name}`
          : ''}
      </Title>
      <Tabs
        onChange={onChange}
        activeKey={activeKey}
        type="editable-card"
        onEdit={''}
        hideAdd
        tabBarExtraContent={
          !userView && (
            <Button
              onClick={add}
              type="primary"
              disabled={currentProject.id === undefined}
            >
              + Dodaj Etap
            </Button>
          )
        }
      >
        >
        {[...tabs, ...localTab].map((tab) => (
          <TabPane
            tab={tab.title}
            key={tab.key}
            closable={tab.closable}
            editing={editing}
          >
            {tab.content}
          </TabPane>
        ))}
      </Tabs>
    </>
  );
};

export default ProjectTabs;
